<template>
	<div class="flex gap-4 py-6 pl-8 pr-6 mb-2 bg-gray-700 border border-gray-600 rounded">
		<div>
			<div class="text-gray-300">
				<slot />
			</div>
			<a
				v-if="learnMoreUrl"
				:href="learnMoreUrl"
				class="block mt-8 text-orange-500 dark:text-yellow-500 text-strong-base"
				target="_blank"
				rel="noreferrer"
			>
				Learn more
				<BaseIcon name="mono/arrow" class="ml-2 w-10 h-10" />
			</a>
		</div>
		<button
			v-if="isToolIntegrationsEnabled"
			class="flex items-center justify-center w-16 h-16 m-4 text-gray-400 hover:text-gray-300"
			@click="$emit('close')"
		>
			<BaseIcon name="mono/delete" />
		</button>
	</div>
</template>

<script>
import {FEATURE_CODES} from 'shared/constants/featureCodes'

export default {
	name: 'BannerSidebar',
	props: {
		learnMoreUrl: {
			type: String,
			default: '',
		},
	},
	emits: ['close'],
	computed: {
		isToolIntegrationsEnabled() {
			return this.$store.hasPlanFeature(FEATURE_CODES.TOOL_INTEGRATIONS)
		},
	},
}
</script>
